// Dropdown Component

import React, { useState, useRef, useEffect } from "react";
import imgArrowDropdown from "../../assets/icon/ic-drop.png";
import "../../css/Dropdown.css";

export default function DropdownProblemType(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(props.selectedOption);
  const dropdownRef = useRef(null);

  useEffect(() => {
    props.onSelect(selectedOption);
  }, [selectedOption]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    toggleDropdown();
  };

  const getDropdownWidth = () => {
    return dropdownRef.current?.offsetWidth || 0;
  };

  return (
    <div className="dropdown-container">
      <div
        className={`dropdown-header ${
          selectedOption.length != 0 ? "selected" : ""
        } ${isOpen ? "open" : ""}`}
        onClick={toggleDropdown}
      >
        {selectedOption.length != 0 ? (
          <img
            className="img-logo"
            src={selectedOption["problem_types"][0]["photo"]}
          />
        ) : null}

        <p
          className={`${
            selectedOption.length != 0
              ? "org-dropdown-selected"
              : "dropdown-not-select"
          }`}
        >
          {selectedOption.length != 0
            ? selectedOption["problem_types"][0]["name"]
            : props.placeholder}
        </p>

        <img className="img-dropdown" src={imgArrowDropdown}></img>
      </div>
      {props.options != undefined ? (
        <div
          className={`dropdown-list ${isOpen ? "open" : ""}`}
          style={{ width: getDropdownWidth() }}
          ref={dropdownRef}
        >
          {props.options.map((option) => (
            <div
              key={option["problem_types"][0].id}
              className="dropdown-option"
              onClick={() => handleOptionClick(option)}
            >
              <img src={option["problem_types"][0]["photo"]} />
              <p>{option["problem_types"][0]["name"]}</p>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
